import { Rectangle } from "../../maths/Rectangle";
import { Pool } from "../../utils/Pool";
export class DrawTexturesCmd {
    static create(texture, pos, colors) {
        var cmd = Pool.getItemByClass("DrawTexturesCmd", DrawTexturesCmd);
        cmd.texture = texture;
        texture._addReference();
        cmd.pos = pos;
        cmd.colors = colors || [];
        return cmd;
    }
    recover() {
        this.texture._removeReference();
        this.texture = null;
        this.pos = null;
        Pool.recover("DrawTexturesCmd", this);
    }
    run(context, gx, gy) {
        context.drawTextures(this.texture, this.pos, gx, gy, this.colors);
    }
    getBounds(assembler) {
        if (this.texture) {
            let w = this.texture.width;
            let h = this.texture.height;
            for (let i = 0, n = this.pos.length; i < n; i += 2) {
                let x = this.pos[i];
                let y = this.pos[i + 1];
                Rectangle.TEMP.setTo(x, y, w, h).getBoundPoints(assembler.points);
            }
        }
    }
    get cmdID() {
        return DrawTexturesCmd.ID;
    }
}
DrawTexturesCmd.ID = "DrawTextures";
